import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDetectOutsideClick } from '../../utils/useDetectOutsideClick';
import { DeleteIcon } from '../icons/DeleteIcon';
import { CONTENT_GROUP_DELETE, CONTENT_GROUP_DUPLICATE, CONTENT_GROUP_SETTINGS } from '../../constants';
import CopyIcon from '../icons/CopyIcon';


function ContentGroupSettingsDropdown(props) {
    const dispatch = useDispatch();
    const { isOpen, boundary, content_group_id, workspace_id, stage_id, can_destroy, can_clone } = useSelector(state => state.card_settings_dropdown);
    const cardSettingsDropdownRef = useRef();
    const [isActive, setIsActive] = useDetectOutsideClick(cardSettingsDropdownRef, false);
    const { innerWidth, innerHeight } = window;

    useEffect(() => {
        setIsActive(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (isActive) {

        } else {
            dispatch({ type: CONTENT_GROUP_SETTINGS.CLOSE_CONTENT_GROUP_SETTINGS });
        }
    }, [isActive]);

    if(!isOpen) {
        return null;
    }
    

    const getDropdownStyle = () => {
        let styles = {}

        const height = 92;
        const width = 240;

        if (innerWidth >= (boundary?.left + 30 + width)){
            styles.left = `${boundary?.left + 30}px`;
        } else {
            styles.left = `${(boundary?.left + 0) - width }px`;
        }

        if (innerHeight >= (boundary?.top + 30 + height)){
        styles.top = `${boundary?.top}px`;
        } else {
            styles.top = `${(boundary?.top + 30 ) - height }px`;
        }

        return styles;
    }

    const handleCopyCardClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if(!can_clone) return;

        // Dispatch action to copy card
        dispatch({ type: CONTENT_GROUP_DUPLICATE.OPEN_DUPLICATE_MODAL, payload: { content_group_id, workspace_id, boundary, stage_id } });
        dispatch({ type: CONTENT_GROUP_SETTINGS.CLOSE_CONTENT_GROUP_SETTINGS })
    }

    const handleDeleteCardClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if(!can_destroy) return;
        
        // Dispatch action to delete card
        dispatch({ type: CONTENT_GROUP_DELETE.OPEN_CARD_DELETE_MODAL, payload: { content_group_id, workspace_id } });
        dispatch({ type: CONTENT_GROUP_SETTINGS.CLOSE_CONTENT_GROUP_SETTINGS });
    }

    return (
        <div 
            className='content-group-settings-dropdown' 
            style={getDropdownStyle()}
            ref={cardSettingsDropdownRef}
        >
            {
                can_clone && 
                <div 
                    className='content-group-settings-dropdown__item d-flex align-items-center cursor-pointer'
                    onClick={handleCopyCardClick}
                >
                    Copy Card
                </div>
            }

            {
                can_destroy && 
                <div className='content-group-settings-dropdown__item d-flex align-items-center cursor-pointer'
                    onClick={handleDeleteCardClick}
                >
                    Move to Recycle Bin
                </div>
            }
               
        </div>
    );
}

export { ContentGroupSettingsDropdown };